import React, { useState } from "react";
import "./dashboard.css";
import onsiteproLogo from "../../../assets/onsitepro-logo.png"; // your logo
import { useNavigate } from "react-router-dom";
import FormHeader from "../../common/FormHeader";

function Dashboard() {
  const [modal, setModal] = useState("");
  const navigate = useNavigate();

  const openModal = (type) => setModal(type);
  const closeModal = () => setModal("");

  return (
    <div className="dashboard-root" style={{overflowY: 'auto', height: '100vh'}}>
      {/* Header */}
      <FormHeader />

      {/* OnSitePro Section Title */}
      <section className="container-fluid mt-4 mb-2">
        <div className="row align-items-center ms-1 ms-md-2">
          <div className="col-12 col-md-auto d-flex align-items-center flex-column flex-md-row">
            <img src={onsiteproLogo} alt="OnSitePro Logo" style={{height:'40px', objectFit:'contain', marginRight:'0', marginBottom:'8px', marginTop:'-4px'}} className="mb-2 mb-md-0 me-0 me-md-2" />
            {/* <span style={{fontWeight:700, color:'#8b1634', fontSize:'2rem', letterSpacing:'-1px', fontFamily:'inherit', display:'flex', alignItems:'center'}}>OnSitePro</span> */}
          </div>
        </div>
      </section>

      {/* KPI/SLA Monitor */}
      <section className="dashboard-kpi">
        <h3 className="ms-2 ms-md-0">KPI/SLA Monitor</h3>
        <div className="kpi-cards row gx-2 gy-3 px-2 px-md-0">
          <div className="kpi-card status-ok col-12 col-md-4">
            <div className="kpi-card-header">
              <i className="fa fa-check-square"></i> Status OK
              <span className="kpi-card-badge">27</span>
            </div>
            <div className="kpi-card-body">
              The outage represents a disruption, but since the services are back to full operation, the SLA is currently being honored.
            </div>
          </div>
          <div className="kpi-card sla-issue col-12 col-md-4">
            <div className="kpi-card-header">
              <i className="fa fa-cog"></i> Impending SLA Issue
              <span className="kpi-card-badge">4</span>
            </div>
            <div className="kpi-card-body">
              SLAs define measurable metrics (like uptime, response time, issue-resolution time) that a provider commits to meeting.
            </div>
          </div>
          <div className="kpi-card sla-failure col-12 col-md-4">
            <div className="kpi-card-header">
              <i className="fa fa-exclamation-triangle"></i> SLA Failure Issue
              <span className="kpi-card-badge">6</span>
            </div>
            <div className="kpi-card-body">
              If the provider fails to adhere to promised encryption, backup, or data protection standards and a breach occurs it constitutes an SLA failure.
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Buttons */}
      <section className="dashboard-nav">
        <h4>Pick One to Continue</h4>
        <div className="dashboard-nav-btns">
          <button className="dashboard-btn" onClick={() => openModal("Login")}>help desk</button>
          <button className="dashboard-btn" onClick={() => openModal("PPM Scheduling")}>PPM Scheduling</button>
          <button className="dashboard-btn" onClick={() => openModal("Reactive Scheduling")}>Reactive Scheduling</button>
          <button className="dashboard-btn" onClick={() => setModal(modal === "Forms" ? "" : "Forms")}>Forms</button>
        </div>
        {/* Expand view for Forms */}
        {modal === "Forms" && (
          <div className="dashboard-forms-expand mt-4 mb-2 p-2 p-md-3" style={{background:'#fff',borderRadius:'14px',boxShadow:'0 2px 12px rgba(139,22,52,0.07)',border:'1px solid #eee'}}>
            <div className="mb-2" style={{fontWeight:600,fontSize:'1.1rem',color:'#8b1634',borderBottom:'2px solid #8b1634',width:'fit-content',marginBottom:'1.1rem'}}>Forms</div>
            <div className="row g-2">
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/rams')}>RAMS</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/pow-assessment')}>POW Assessment</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/site-register')}>Site Register</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/work-at-height')}>Work at Height</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/mewp-checklist')}>MEWP Checklist</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/ppm-report')}>PPM Report</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/ukpn-ppm')}>UKPN PPM</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/lser-callout')}>LSER Call out</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/ukpn-mst')}>UKPN MST</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/tbs-ukpn')}>TBS UKPN</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/pre-fabricated')}>PRE Fabricated</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/accident-report')}>Accident Report</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/asbestos-briefing')}>Asbestos briefing</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/additional-concerns')}>Additional concerns</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/ukpn-reactive')}>UKPN Reactive</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/daily-worksheet')}>Daily Worksheet</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/tts-daily-worksheet')}>TTS Daily Worksheet</button></div>
              <div className="col-6 col-md-3"><button className="dashboard-btn btn btn-sm w-100" onClick={() => navigate('/lser-ppm-daily-checklist')}>LSER PPM Daily checklist</button></div>
            </div>
          </div>
        )}
      </section>

      {/* Modal */}
      {modal && modal !== "Forms" && (
        <div className="dashboard-modal-overlay" style={{position: 'fixed', top:0, left:0, width:'100vw', height:'100vh', background:'rgba(0,0,0,0.18)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center'}}>
          <div className="dashboard-modal" style={{background:'#fff', borderRadius:'16px', boxShadow:'0 4px 24px rgba(139,22,52,0.13)', padding:'2rem', minWidth:'320px', maxWidth:'90vw', position:'relative'}}>
            <button onClick={closeModal} style={{position:'absolute', top:'16px', right:'16px', background:'none', border:'none', fontSize:'1.5rem', color:'#8b1634', cursor:'pointer'}}>&times;</button>
            <h3 style={{color:'#8b1634', marginBottom:'1.2rem'}}>{modal}</h3>
            <div>
              {/* Modal content placeholder */}
              <p>This is a modal for <b>{modal}</b>. You can add your form or content here.</p>
            </div>
          </div>
        </div>
      )}

      {/* Charts Section */}
      <section className="dashboard-charts">
        <div className="dashboard-chart-title-col">
          <h4 className="dashboard-chart-title">Site Maintenance</h4>
          <div className="dashboard-chart maintenance">
            <img src="https://quickchart.io/chart?c=%7B%22type%22%3A%22line%22%2C%22data%22%3A%7B%22labels%22%3A%5B%22Figma%22%2C%22Sketch%22%2C%22XD%22%2C%22PS%22%2C%22AI%22%5D%2C%22datasets%22%3A%5B%7B%22label%22%3A%222020%22%2C%22data%22%3A%5B100%2C80%2C90%2C40%2C90%5D%2C%22borderColor%22%3A%22rgba(0%2C200%2C255%2C0.7)%22%2C%22pointBackgroundColor%22%3A%22rgba(0%2C200%2C255%2C1)%22%2C%22fill%22%3Afalse%7D%2C%7B%22label%22%3A%222021%22%2C%22data%22%3A%5B40%2C60%2C80%2C60%2C90%5D%2C%22borderColor%22%3A%22rgba(255%2C0%2C0%2C0.3)%22%2C%22pointBackgroundColor%22%3A%22rgba(255%2C0%2C0%2C0.7)%22%2C%22fill%22%3Afalse%7D%2C%7B%22label%22%3A%222022%22%2C%22data%22%3A%5B80%2C90%2C70%2C20%2C80%5D%2C%22borderColor%22%3A%22rgba(100%2C100%2C255%2C0.5)%22%2C%22pointBackgroundColor%22%3A%22rgba(100%2C100%2C255%2C1)%22%2C%22fill%22%3Afalse%7D%5D%7D%2C%22options%22%3A%7B%22scales%22%3A%7B%22yAxes%22%3A%5B%7B%22ticks%22%3A%7B%22beginAtZero%22%3Atrue%7D%7D%5D%7D%7D%7D" alt="Site Maintenance Chart" className="dashboard-chart-img" />
          </div>
        </div>
        <div className="dashboard-chart-title-col">
          <h4 className="dashboard-chart-title">Site installation Monitor</h4>
          <div className="dashboard-chart installation">
            <img src="https://quickchart.io/chart?c=%7B%22type%22%3A%22pie%22%2C%22data%22%3A%7B%22labels%22%3A%5B%22Figma%22%2C%22XD%22%2C%22Lizard%22%2C%22Photoshop%22%2C%22AI%22%5D%2C%22datasets%22%3A%5B%7B%22data%22%3A%5B2%2C1%2C1%2C1%2C0%5D%2C%22backgroundColor%22%3A%5B%22%23fa8c8c%22%2C%22%232ec7e6%22%2C%22%235e72e4%22%2C%22%23a084e8%22%2C%22%23ffb84c%22%5D%7D%5D%7D%7D" alt="Site Installation Chart" className="dashboard-chart-img" />
            <div className="dashboard-chart-properties mb-3">
              <div className="text-center mb-2">
                <span className="dashboard-chart-total">5</span>
                <span style={{fontWeight:600, fontSize:'1.15rem', display:'block', marginBottom:'0.2rem'}}>Total Properties</span>
              </div>
              <div className="dashboard-custom-legend d-flex justify-content-center align-items-center gap-4 mt-3">
                <span className="d-flex align-items-center gap-1"><span style={{display:'inline-block',width:'12px',height:'12px',borderRadius:'50%',background:'#fa8c8c'}}></span><span style={{color:'#555',fontWeight:500}}>Figma</span></span>
                <span className="d-flex align-items-center gap-1"><span style={{display:'inline-block',width:'12px',height:'12px',borderRadius:'50%',background:'#2ec7e6'}}></span><span style={{color:'#555',fontWeight:500}}>XD</span></span>
                <span className="d-flex align-items-center gap-1"><span style={{display:'inline-block',width:'12px',height:'12px',borderRadius:'50%',background:'#5e72e4'}}></span><span style={{color:'#555',fontWeight:500}}>Uizard</span></span>
                <span className="d-flex align-items-center gap-1"><span style={{display:'inline-block',width:'12px',height:'12px',borderRadius:'50%',background:'#a084e8'}}></span><span style={{color:'#555',fontWeight:500}}>Photoshop</span></span>
                <span className="d-flex align-items-center gap-1"><span style={{display:'inline-block',width:'12px',height:'12px',borderRadius:'50%',background:'#ffb84c'}}></span><span style={{color:'#555',fontWeight:500}}>AI</span></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="dashboard-footer">
        ©2025 All right reserved
      </footer>
    </div>
  );
}

export default Dashboard;